import React from 'react';
import { Card, SageClassnames, Textarea } from '@kajabi/sage-react';
import useEditResultItem from 'common/components/CopyMagic/hooks/useResultEditItem';
import { postBodySchema } from 'common/components/CopyMagic/shared/validationSchema';

const PostBodyInput = ({ attributePath }: { attributePath: (string | number)[] }) => {
  const { inputName, onChangeHandler, onFocusHandler, onBlurHandler, value, errorMessage } =
    useEditResultItem({ attributePath, validationSchema: postBodySchema });

  return (
    <Card.Block className={SageClassnames.SPACERS.SM_LEFT}>
      <Textarea
        name={inputName}
        id={inputName}
        onChange={onChangeHandler}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
        value={value}
        defaultFieldValue={value}
        label="Description"
        message={errorMessage}
        hasError={!!errorMessage.length}
        rows={1}
      />
    </Card.Block>
  );
};

export default PostBodyInput;
